import { render, staticRenderFns } from "./RightColumn.vue?vue&type=template&id=5d72e84e&scoped=true"
import script from "./RightColumn.vue?vue&type=script&lang=js"
export * from "./RightColumn.vue?vue&type=script&lang=js"
import style0 from "./RightColumn.vue?vue&type=style&index=0&id=5d72e84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d72e84e",
  null
  
)

export default component.exports